import { encode as base64encode } from 'base64-arraybuffer'
export const generateCodeChallenge = async (codeVerifier: string) => {
  const encoder = new TextEncoder()
  const data = encoder.encode(codeVerifier)
  const digest = await window.crypto.subtle.digest('SHA-256', data)
  const base64Digest = base64encode(digest)
  return base64Digest.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
}
